import { accent, ink, dc, dcSoft } from "../hooks/tokens.js";
import { ARTICLES } from "../data.js";

// Écran fiche : contenu, plateforme CLI, favoris, onglets Fiche/Historique/Notes.
export function buildArticleView(ctx) {
  const { s, patch, go, art, idx, saveNotes, syncNote, syncBookmark } = ctx;

  return {
    article: art, articleDomain: art.domain, hasTable: !!art.table,
    hasBody: !!art.bodyHtml, bodyHtml: art.bodyHtml,
    toc: [...(art.table ? ["Ordre de sélection"] : []), "Vérifier en production", "Pièges fréquents"],
    siblingArticles: ARTICLES.filter((a) => a.domain === art.domain).map((a) => ({
      title: a.title, color: a.id === art.id ? dc(art.domain) : ink,
      bg: a.id === art.id ? dcSoft(art.domain) : "transparent",
      onClick: () => go(a.id),
    })),
    bgpAttrs: [
      { n: "1", attr: "weight", rule: "Plus grand gagne", scope: "Routeur local" },
      { n: "2", attr: "local-preference", rule: "Plus grand gagne", scope: "Dans l'AS" },
      { n: "3", attr: "origine locale", rule: "network / redistribute / agrégat", scope: "Routeur local" },
      { n: "4", attr: "as-path", rule: "Le plus court gagne", scope: "Inter-AS" },
      { n: "5", attr: "origin", rule: "IGP < EGP < incomplete", scope: "Inter-AS" },
      { n: "6", attr: "med", rule: "Plus petit gagne, même AS voisin", scope: "Inter-AS" },
    ],
    // Le "97 0.02 55" / "42 0.08 55" venait d'un lookup HUE[art.domain] qui
    // n'a jamais été renseigné nulle part — toujours retombé sur 55.
    platforms: ["IOS-XE", "Junos", "NX-OS"].map((p) => ({
      name: p, color: p === s.platform ? "oklch(0.97 0.02 55)" : "oklch(0.68 0.015 70)",
      bg: p === s.platform ? "oklch(0.42 0.08 55)" : "transparent",
      weight: p === s.platform ? "500" : "400",
      onClick: () => patch({ platform: p, copied: false }),
    })),
    cliCode: art.cli[s.platform] || art.cli["IOS-XE"],
    copyLabel: s.copied ? "Copié ✓" : "Copier",
    copyCli: () => {
      const txt = art.cli[s.platform] || "";
      if (!navigator.clipboard) { console.error("[netdoc] clipboard API unavailable"); return; }
      navigator.clipboard.writeText(txt).then(() => {
        patch({ copied: true });
        setTimeout(() => patch({ copied: false }), 1600);
      }).catch((e) => console.error("[netdoc] clipboard copy failed:", e.message));
    },
    bookmarked: !!s.bookmarks[art.id],
    bookmarkLabel: s.bookmarks[art.id] ? "Retirer des favoris" : "Ajouter aux favoris",
    toggleBookmark: () => {
      const next = !s.bookmarks[art.id];
      patch({ bookmarks: { ...s.bookmarks, [art.id]: next } });
      syncBookmark(art.id, next);
    },
    prevTitle: ARTICLES[(idx - 1 + ARTICLES.length) % ARTICLES.length].title,
    nextTitle: ARTICLES[(idx + 1) % ARTICLES.length].title,
    prevArticle: () => go(ARTICLES[(idx - 1 + ARTICLES.length) % ARTICLES.length].id),
    nextArticle: () => go(ARTICLES[(idx + 1) % ARTICLES.length].id),

    /* ---------- onglets de fiche ---------- */
    // L'onglet Historique a été retiré (todo.md, P2) : il montrait un faux
    // journal de révisions (hash/auteurs/dates inventés) sans donnée réelle
    // derrière — ni git, ni table Supabase. Rien à brancher dessus
    // aujourd'hui ; à réintroduire seulement avec une vraie source.
    articleTabs: [
      { k: "article", label: "Fiche" },
      { k: "notes", label: (s.notes[art.id] ? "Notes ·" : "Notes") },
    ].map((t) => ({ label: t.label,
      color: s.articleTab === t.k ? "oklch(0.24 0.012 60)" : "oklch(0.55 0.015 60)",
      line: s.articleTab === t.k ? accent : "transparent",
      onClick: () => patch({ articleTab: t.k }) })),
    tabArticle: s.articleTab === "article", tabNotes: s.articleTab === "notes",

    /* ---------- notes personnelles ---------- */
    noteText: s.notes[art.id] || "",
    onNote: (e) => { saveNotes({ ...s.notes, [art.id]: e.target.value }); syncNote(art.id, e.target.value); },
    noteStat: (s.notes[art.id] ? s.notes[art.id].trim().split(/\s+/).filter(Boolean).length : 0) + " mots · enregistré",
    exportNotes: () => {
      const lines = Object.keys(s.notes).filter((k) => s.notes[k] && s.notes[k].trim()).map((k) => {
        const a = ARTICLES.find((x) => x.id === k);
        return "## " + (a ? a.title : k) + "\n\n" + s.notes[k].trim() + "\n";
      });
      const blob = new Blob(["# Notes netdoc\n\n" + lines.join("\n")], { type: "text/markdown" });
      const url = URL.createObjectURL(blob);
      const el = document.createElement("a");
      el.href = url; el.download = "notes-netdoc.md"; el.click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    },
    hasOtherNotes: Object.keys(s.notes).filter((k) => k !== art.id && s.notes[k] && s.notes[k].trim()).length > 0,
    otherNotes: Object.keys(s.notes).filter((k) => k !== art.id && s.notes[k] && s.notes[k].trim()).map((k) => {
      const a = ARTICLES.find((x) => x.id === k);
      return { title: a ? a.title : k, excerpt: s.notes[k].trim().slice(0, 90), onClick: () => patch({ screen: "article", articleId: k, articleTab: "notes" }) };
    }),
  };
}
